module.exports = __webpack_public_path__ + "static/img/level-card-banner2.cf86fd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/level-card-banner2.png
// module id = XC/U
// module chunks = 1